import getReduxSelector from 'modules/redux/selectors/get'
import { CUSTOMER_KEY, CUSTOMER_PATH } from 'modules/customer/redux/state'

const getSampleHistoryCustomerSelect = state => {
  const path = CUSTOMER_PATH[CUSTOMER_KEY.SAMPLE_HISTORY]
  return getReduxSelector(path)(state)
}

export default getSampleHistoryCustomerSelect
